/**
 * @author 胡小右
 * @date 2022-06-17 19:46:00
 * @desc 精确加法 plus 精确减法 minus 精确乘法 times  精确除法 divide 包含部分正则表达式
 */
import NP, { plus, minus, times, divide } from 'number-precision';

NP.enableBoundaryChecking(false);

/**
 * @author: 胡小右
 * @description: '截取两位小数'
 * @params: num:number | string
 * @date: 2021/11/15 2:20 下午
 */
export function toFixedTwoNum(num: number | string) {
    return divide(Math.floor(times(num || 0, 100)), 100).toFixed(2);
}

/**
 * @author: 胡小右
 * @description: '截取两位小数'
 * @params: num:number | string
 * @date: 2021/11/15 2:20 下午
 */
export function toFixedThreeNum(num: number | string) {
    return divide(Math.floor(times(num || 0, 1000)), 1000).toFixed(3);
}

/**
 * @author: 胡小右
 * @description: '加法'
 * @params: num1:string|number,num2:string | number
 * @date: 2021/11/15 2:23 下午
 */
export function getPlus(num1: string | number, num2: string | number) {
    return plus(num1, num2);
}

/**
 * @author: 胡小右
 * @description: '减法'
 * @params: num1:string|number,num2:string | number
 * @date: 2021/11/15 2:24 下午
 */
export function getMinus(num1: string | number, num2: string | number) {
    return minus(num1, num2);
}

/**
 * @author: 胡小右
 * @description: '乘法'
 * @params: num1: string | number, num2: string | number
 * @date: 2021/11/15 2:26 下午
 */
export function getTimes(num1: string | number, num2: string | number) {
    return times(num1, num2);
}

/**
 * @author: 胡小右
 * @description: '除法，num2为0时默认return 0'
 * @params: num1: string | number, num2: string | number
 * @date: 2021/11/15 2:27 下午
 */
export function getDivide(num1: string | number, num2: string | number) {
    if (Number(num2) !== 0) {
        return divide(num1, num2);
    }
    return 0;
}
